import React from 'react';
import PropTypes from 'prop-types';
import { default as partnerLogo } from '../../../images/Industry_Experts_Badge.svg';
import Filter from '../../Common/Filter/Filter';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import './IndustryExpertsHeader.scss';

const IndustryExpertsHeader = ({
  scrollToContent,
  isCreativePartnerPage = false
}) => {

  const onSelect = e =>  scrollToContent(e);

  return (
    <>
      <div className={`industry-experts-header ${isCreativePartnerPage && 'all-creative-partner-page'}`}>
        <div className="industry-experts-header-event-partner-img">
          <CommunityImg src={partnerLogo} alt="partner logo" />
        </div>
        <div className="industry-experts-header-event-partner">
          <div className="industry-experts-header-event-partner-title">
            Industry Experts
          </div>
          <div className="industry-experts-header-event-partner-subtitle">
          We’ve partnered with the best-in-the-business to bring you all the resources you’ll need to build and grow a brand. With Experts spanning all specialties - from marketing, to logistics, to sustainability - this collective is designed to be your one-stop-shop for small biz support.
          </div>
        </div>
        {
          !isCreativePartnerPage &&
          <div className="industry-experts-header-event-partner-join">
            I want to...
            <Filter
              cls='industry-experts-header-event-dropdown'
              width={380}
              defaultSelection={'Find An Expert'}
              filterData={['Find An Expert', 'Get Biz Advice', 'Become an Industry Expert']}
              onSelect={onSelect}
            />
          </div>
        }
      </div>
    </>
  )
}

IndustryExpertsHeader.propTypes = {
  isAllEvents: PropTypes.bool
}

IndustryExpertsHeader.defaultProps = {
  isAllEvents: false,
}

export default IndustryExpertsHeader;